import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Theme from './app/components/Theme';
import DocumentScene from './app/scenes/Document/components/Document';

ReactDOM.render( // 👈️ deprecated starting React 18
  <React.StrictMode>
    <Theme>
      <DocumentScene />
    </Theme>
  </React.StrictMode>,
  document.getElementById('root'),
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
